import { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

const useGetAccountInfo = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserInfo = () => {
    setIsLoading(true);
    setError(null);

    let req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axiosInstance(req)
      .then((res) => {
        setUserInfo(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching user credit data:", err);
        setError(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return {
    userInfo,
    isLoading,
    error,
    refetchCredits: fetchUserInfo,
  };
};

export default useGetAccountInfo;
